let header = jQuery('.header')

jQuery('.body__before').on('click', function(e) {

    if( !jQuery( 'body' ).hasClass( 'is-modal' ) )
        jQuery( '.header .hamburger' ).trigger( 'click' )

})

jQuery(document).on('keydown', function(event) {
    if (event.key == "Escape") {

        if( jQuery('body').hasClass('is-drawer') ){

            if (jQuery('.hamburger-toggle .hamburger').hasClass('is-active'))
                jQuery('.drawer').attr('tabindex', '-1')
            else
                jQuery('.drawer').attr('tabindex', '1').focus()

            jQuery('body').toggleClass('is-drawer')
            jQuery('.hamburger').toggleClass('is-active')

        }
    }
});


jQuery('.hamburger-toggle').on('click', function (e) {

    e.preventDefault()

    if (jQuery(this).find('.hamburger--spin').hasClass('is-active')) {
        setTimeout( function(){ document.getElementById( 'hamburger-toggle' ).focus() }, 100)

        jQuery('.drawer').attr('tabindex', '-1')
        document.documentElement.className = ''
    } else {
        setTimeout( function(){ document.getElementById( 'drawer-logo' ).focus() }, 100)

        jQuery('.drawer').attr('tabindex', '1')
        document.documentElement.className = 'no-overflow-call'
    }

    jQuery('body').toggleClass('is-drawer')
    jQuery('.hamburger').toggleClass('is-active')

})

jQuery('.drawer__nav .toggle, .drawer__login .toggle').on('click', function (e) {
    e.preventDefault()

    let thisEl = jQuery(this),
        parentEl = thisEl.parent()

    if (parentEl.hasClass('open')) {
        parentEl.toggleClass('open').next().slideToggle()
    } else {
        parentEl.toggleClass('open', false).next().slideToggle()
        parentEl.addClass( 'open' )
    }
})

var lastScrollTop = 0

jQuery(window).on('scroll', function () {
    let scrollTop = jQuery(window).scrollTop()

    if ( scrollTop > 40 ) {
        jQuery('.first-nav__holder').css( { 'visibility' : 'hidden' } )
        jQuery('.header').addClass( 'header--white' )
    } else {
        jQuery('.first-nav__holder').css( { 'visibility' : 'visible' } )
        jQuery('.header').removeClass( 'header--white' )
    }

    if( lastScrollTop > scrollTop ) {
        jQuery('.first-nav__holder').css( { 'visibility' : 'visible' } )
        jQuery('.first-nav__holder').addClass( 'first-nav__holder--white' )
    }

    if( scrollTop > lastScrollTop || scrollTop <= 40 )
        jQuery('.first-nav__holder').removeClass( 'first-nav__holder--white' )

    lastScrollTop = scrollTop
})

jQuery(document).ready(function () {
    let scrollTop = jQuery(window).scrollTop()

    if ( scrollTop > 40 ) {
        jQuery('.first-nav__holder').css( { 'visibility' : 'hidden' } )
        jQuery('.header').addClass( 'header--white' )
    } else {
        jQuery('.first-nav__holder').css({ 'visibility': 'visible' } )
        jQuery('.header').removeClass( 'header--white' )
    }

    if( lastScrollTop > scrollTop ) {
        jQuery('.first-nav__holder').css({ 'visibility': 'visible' } )
        jQuery('.first-nav__holder').addClass( 'first-nav__holder--white' )
    }

    if( scrollTop > lastScrollTop || scrollTop <= 40 )
        jQuery('.first-nav__holder').removeClass( 'first-nav__holder--white' )

    lastScrollTop = scrollTop
})



//Close drawer on keyboard tabbing, if it goes to .home or .header (meaning it is outside .drawer)
jQuery('.header, .home').focusin(function() {
    let drawer = document.getElementById("drawer");
    if(!drawer.contains(document.activeElement) && jQuery('body').hasClass('is-drawer')){
                if (jQuery('.hamburger-toggle .hamburger').hasClass('is-active'))
                    jQuery('.drawer').attr('tabindex', '-1')
                else
                    jQuery('.drawer').attr('tabindex', '1').focus()

                jQuery('body').toggleClass('is-drawer')
                jQuery('.hamburger').toggleClass('is-active')
    }
})

jQuery('.my-search').on('click', function (e) {

    e.preventDefault()

    if(jQuery('.form__search').hasClass('form-is-active')){
        jQuery('.form__search').removeClass('form-is-active');

    } else {
        jQuery('.form__search').addClass('form-is-active');
        jQuery('.my-search').addClass('form__search');
        var form = jQuery('#nsi');
        jQuery('#nsi').focus();

        form.on('focusout', (event) => {
            jQuery('.form__search').removeClass('form-is-active');
            jQuery('.my-search').removeClass('form__search');
            if(jQuery(window).width() < 768 ){
                jQuery('.header__logo__wrap').removeClass('form__search');
                jQuery('.cart').removeClass('form__search');
                jQuery('.my-account').removeClass('form__search');
                jQuery('.header__right').removeClass('form-is-active');
            }
        });

        if(jQuery(window).width() < 768 ){
            jQuery('.header__logo__wrap').addClass('form__search');
            jQuery('.cart').addClass('form__search');
            jQuery('.my-account').addClass('form__search');
            jQuery('.header__right').addClass('form-is-active');
        }
    }

})

jQuery('#showUserway').on('click', function (e) {

    e.preventDefault()

    console.log(jQuery("#userwayAccessibilityIcon"))
    // jQuery(".uwif")[0].show()
    // jQuery(".uwif").css("display", "block");
    jQuery("#userwayAccessibilityIcon").trigger("click")
    // var close_icon = jQuery('.uwaw-header__close')
    //
    // close_icon.on('click', (event) => {
    //     jQuery(".uwif").hide()
    // });

})
